import type { OptimizationBlockState } from '../../../lib/optimization/types'
import {
  filterContactRecommendationsByProgress,
  type FeedbackProgressContext,
} from '../../../lib/optimization/qualityFeedbackProgress'

interface OptimizationContactRecommendationsProps {
  block?: OptimizationBlockState
  progressContext?: FeedbackProgressContext
}

function recommendationList(block: OptimizationBlockState): string[] {
  const fb = block.agent_feedback
  if (!fb) return []
  const raw = fb.contact_recommendations ?? fb.recommendations
  if (!Array.isArray(raw)) return []
  return raw.filter((item): item is string => typeof item === 'string' && item.trim().length > 0)
}

export default function OptimizationContactRecommendations({
  block,
  progressContext,
}: OptimizationContactRecommendationsProps) {
  const rawItems = block ? recommendationList(block) : []
  const items = progressContext
    ? filterContactRecommendationsByProgress(rawItems, progressContext)
    : rawItems
  if (!items.length) return null

  return (
    <div
      className="mt-3 rounded-lg border border-amber-200 bg-amber-50/80 px-3 py-2 text-xs text-amber-950"
      data-testid="contact-optimization-recommendations"
    >
      <p className="font-semibold text-amber-900">Contact tailoring suggestions</p>
      <ul className="mt-1.5 ml-1 list-disc list-outside space-y-1 pl-4">
        {items.map((item, index) => (
          <li key={`${index}-${item}`}>{item}</li>
        ))}
      </ul>
    </div>
  )
}
